/* eslint-disable */

import $ from 'jQuery';
// import data from '../public/from-server.json';


const apiUrl = 'https://backoffice.drawbotics.com/api/public/v1/projects/coeur-de-ville';

let unitTable;
let tableHeader;

function init() {
  unitTable = $('.tab-table');
  tableHeader = $('.table-header')[0];

  $.ajax({
    url: apiUrl,
    type: 'GET',
    crossDomain: true,
    crossOrigin: true,
  }).done(_requestSuccess);
}


function _requestSuccess(response) {
  if (response.resource.length === 0) {
    return false;
  }

  const listings = response.resource.buildings.map((b) => b.floors.map((f) => f.units))[0];
  const normalized = listings.reduce((a, b) => a.concat(b), []).sort((a, b) => a.bedrooms - b.bedrooms);

  normalized.map((unit) => {
    if (unit.availability != 'available') {
      const domElement = document.getElementById('price' + unit.reference);
      if (domElement != undefined) {
        domElement.innerHTML = 'Vendu';
      }
    }
  });
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./src/static/js/modules/listing.js